<app-ets-component-router [embedName]="embedName">
  <app-ets-menu-buttons [mode]="mode" [embedName]="embedName" [identifier]="identifier" [redirectprofile]="redirectprofile" [redirectbasket]="redirectbasket"></app-ets-menu-buttons>
</app-ets-component-router>
